import SectionShell from "@/pages/home/components/SectionShell";
import { profileFacts, profileImage, profileIntro, siteName } from "@/mocks/home";

export default function ProfileSection() {
  return (
    <SectionShell
      id="profile"
      num="02"
      eyebrow="FILM PROFILE"
      title="影片速览：一张图看懂它的样子"
      desc="先把关键信息摆在前面——版本、画质、语言与观看方式，一眼确认是不是你要找的那一部。"
      tone="tint"
    >
      <div className="grid grid-cols-1 gap-8 lg:grid-cols-[0.95fr_1.05fr] lg:gap-12">
        <div className="overflow-hidden rounded-xl border border-background-200/70 bg-background-50">
          <div className="relative aspect-[9/7] w-full lg:aspect-[9/8]">
            <img
              src={profileImage}
              alt={`${siteName} 影片速览 场景画面`}
              title={`${siteName} 未删减高清资源 画面`}
              className="h-full w-full object-top object-cover"
            />
          </div>
          <div className="flex items-center justify-between gap-4 border-t border-background-200/70 px-5 py-4">
            <div className="flex items-center gap-2 text-sm text-foreground-600">
              <i className="ri-map-pin-line text-accent-500" />
              取景：原野 · 城市 · 海岸
            </div>
            <span className="rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-900">
              文艺长片
            </span>
          </div>
        </div>

        <div className="flex flex-col">
          <p className="text-[15px] leading-8 text-foreground-700">{profileIntro}</p>

          <dl className="mt-8 grid grid-cols-1 gap-px overflow-hidden rounded-xl border border-background-200/70 bg-background-200/70 sm:grid-cols-2">
            {profileFacts.map((fact) => (
              <div key={fact.label} className="bg-background-50 px-5 py-4">
                <dt className="text-xs tracking-[0.16em] text-foreground-500">{fact.label}</dt>
                <dd className="mt-1.5 font-heading text-base font-bold text-foreground-950">
                  {fact.value}
                </dd>
              </div>
            ))}
          </dl>

          <div className="mt-8 flex flex-col gap-3 rounded-xl border border-primary-200/70 bg-primary-100/60 p-5 sm:flex-row sm:items-center sm:justify-between">
            <p className="text-sm leading-6 text-primary-900">
              想直接看？完整版在线观看与网盘入口都放在下方资源区。
            </p>
            <a
              href="#resource"
              className="inline-flex shrink-0 items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 dark:text-foreground-950"
            >
              前往资源区
              <i className="ri-arrow-down-line" />
            </a>
          </div>
        </div>
      </div>
    </SectionShell>
  );
}